import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import axios from 'axios';
import translate from '../../../translate';
import UserProp from '../../../propTypes/userProp';
import CountryProp from '../../../forms/Address/CountryProp';
import Notifications from '../../../../services/notifications';
import withCSRF from '../../../withCSRF';
import { compose } from '../../../../services/utilityFunctions';
import LoggedUserContext from '../../../../contextProviders/LoggedUserContext';
import MarketInfosContext from '../../../../contextProviders/MarketInfosContext';

function CountrySelector({ t, _csrf, profile, countries }) {
  const [countryFilter, setCountryFilter] = useState('');
  const { loggedUser } = useContext(LoggedUserContext);
  const { setMarketInfos } = useContext(MarketInfosContext);

  const handleCountryFilterChange = ({ currentTarget }) =>
    setCountryFilter(currentTarget.value);

  const handleCountrySelection = shippingCountry => {
    axios
      .put(
        '/api/user/me/settings',
        { shippingCountry },
        {
          headers: {
            'Accept-Version': '1.0.0',
            'X-Gamification-API': 'Organization',
            'X-CSRF-Token': _csrf,
            _csrf,
          },
        },
      )
      .then(() => {
        setMarketInfos('localCountry', shippingCountry);
        Notifications.showNotificationSuccess(
          t('success'),
          t('success_update'),
        );
        window.location.reload();
      })
      .catch(err => {
        Notifications.showErrorFromRequest(err, 'error_profileUpdate');
      });
  };

  const handleCountryLocalStorage = country => {
    setMarketInfos('localCountry', country);
  };

  const filteredCountry = countryFilter
    ? countries.filter(l =>
        l.name.toUpperCase().includes(countryFilter.toUpperCase()),
      )
    : countries;

  const profileCountry = profile && profile.shippingCountry;
  const selectedCountry =
    profileCountry && countries && countries.length > 0
      ? countries.find(l => l.code === profileCountry.toUpperCase()) || {}
      : {};
  const selectedFlag =
    selectedCountry && selectedCountry.flag ? selectedCountry.flag.thumb : null;
  const selectedCode =
    selectedCountry && selectedCountry.code
      ? selectedCountry.code
      : profileCountry;

  return (
    <li
      /* eslint-disable-next-line max-len */
      className="m-nav__item m-topbar__languages m-dropdown m-dropdown--small m-dropdown--arrow m-dropdown--align-right m-dropdown--mobile-full-width"
      m-dropdown-toggle="click"
      aria-expanded="false"
      style={{ marginRight: '1rem' }}
    >
      <a href="#" className="m-nav__link m-dropdown__toggle">
        <span className="m-nav__link-text">
          {selectedFlag ? (
            <img
              alt="language-preview"
              className="m-topbar__language-selected-img"
              src={selectedFlag}
            />
          ) : (
            selectedCode.toUpperCase()
          )}
        </span>
      </a>
      <div className="m-dropdown__wrapper" style={{ zIndex: '101' }}>
        <span
          className="m-dropdown__arrow m-dropdown__arrow--right m-dropdown__arrow--adjust"
          style={{ left: 'auto', right: '5px' }}
        />
        <div className="m-dropdown__inner">
          <div className="m-dropdown__header m--align-center">
            <span className="m-dropdown__header-subtitle">
              {t('header.select.country')}
            </span>
          </div>
          <div className="m-dropdown__body">
            <input
              type="text"
              placeholder={t('header.select.country.placeholder')}
              value={countryFilter}
              onChange={handleCountryFilterChange}
              className="form-control m-input"
              style={{ marginBottom: '1rem' }}
            />
            <div
              className="m-dropdown__content"
              style={{
                maxHeight: '600px',
                overflowY: 'auto',
              }}
            >
              <ul className="m-nav m-nav--skin-light">
                {filteredCountry.map(l => (
                  <li
                    key={l.code}
                    className={cx({
                      'm-nav__item': true,
                      'm-nav__item--active': l.code === selectedCountry.code,
                    })}
                  >
                    <a
                      href="#"
                      onClick={() =>
                        loggedUser
                          ? handleCountrySelection(l.code)
                          : handleCountryLocalStorage(l.code)
                      }
                      className={cx({
                        'm-nav__link': true,
                        'm-nav__link--active': l.code === selectedCountry.code,
                      })}
                    >
                      <span className="m-nav__link-icon">
                        {l.flag && l.flag.thumb ? (
                          <img
                            alt="language flag"
                            className="m-topbar__language-img"
                            src={l.flag.thumb}
                            loading="lazy"
                          />
                        ) : (
                          l.code.toUpperCase()
                        )}
                      </span>
                      <span className="m-nav__link-title m-topbar__language-text m-nav__link-text">
                        {l.name}
                      </span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </li>
  );
}

CountrySelector.propTypes = {
  t: PropTypes.func.isRequired,
  _csrf: PropTypes.string.isRequired,
  profile: PropTypes.shape(UserProp.propType).isRequired,
  countries: PropTypes.arrayOf(PropTypes.shape(CountryProp.propType))
    .isRequired,
};

export default compose(translate, withCSRF)(CountrySelector);
